module.exports = __webpack_public_path__ + "fonts/Red_Hat_Text-400-latin-ext3.c1506c7.woff2";